import React, { useCallback, useState } from 'react';
import { notification } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import type { IReportPermissionRecord } from '@op/components/ReportPermission/types';
import type { IReportPermissionTarget } from '@op/services/report';

export type { IReportPermissionRecord } from '@op/components/ReportPermission/types';

export function useOpenReportPermission() {
  const { formatMessage } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [target, setTarget] = useState<IReportPermissionTarget | null>(null);

  const close = useCallback(() => {
    setVisible(false);
    setTarget(null);
  }, []);

  const open = useCallback(
    (record: IReportPermissionRecord, event?: React.MouseEvent) => {
      event?.stopPropagation();
      event?.preventDefault();

      if (!record?.can_edit_permission) return;

      if (
        !record?.object_type ||
        record.object_id === null ||
        record.object_id === undefined
      ) {
        notification.error({
          description: formatMessage({ id: 'Request failed' }),
        });
        return;
      }

      setTarget({
        object_type: record.object_type,
        object_id: Number(record.object_id),
      });
      setVisible(true);
    },
    [formatMessage],
  );

  const openByTarget = useCallback((nextTarget: IReportPermissionTarget) => {
    setTarget({
      object_type: nextTarget.object_type,
      object_id: Number(nextTarget.object_id),
    });
    setVisible(true);
  }, []);

  return {
    visible,
    target,
    open,
    openByTarget,
    close,
  };
}
